export class Profession {
  constructor(
    public name: string,
    public summary: string = null,
    public referenceUrl: string = null,
  ) { }
}
